import axios from "../../../api/axios";

/**
 * @param {Object} param0
 * @param {File} param0.profileImg
 * @param {string[]} param0.languages
 * @param {string} param0.description
 * @returns {Promise<Object>}
 */
export const becomeEmployer = async ({
  profileImg,
  languages,
  description,
  companyName,
}) => {
  try {
    const formData = new FormData();
    formData.append("attachment", profileImg);
    const imgResponse = await axios.post("attachments/one", formData);

    let image = {
      publicId: imgResponse.data.attachment.publicId,
      imgUrl: imgResponse.data.attachment.url,
    };
    const response = await axios.post("/users/become-employer", {
      profileImg: image,
      languages,
      description,
      companyName
    });
    return response.data.user
  } catch (e) {
    throw new Error(e)
  }
};
